import { render, staticRenderFns } from "./CardOrderResellerPrices.vue?vue&type=template&id=d21dd1b8&"
import script from "./CardOrderResellerPrices.vue?vue&type=script&lang=js&"
export * from "./CardOrderResellerPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports